// Platzhalter in Mailvorlagen. inviteTalent (create-email.js) ersetzt sie nach
// generateHTML per replaceAll im HTML. Ein Token wirkt deshalb nur, wenn es
// genau so und ohne Formatierung in der Mitte im Text steht.
//
// key ist der i18n-Schlüssel unter mail_template.edit_mail_template.placeholder.
export const PLACEHOLDERS = {
  COMPANY_NAME: { token: '{{partner.display_name}}', key: 'companyname' },
  CAREER_TITLE: {
    token: '{{career.title}}',
    key: 'career_title',
    requiresCareer: true
  },
  ASSESSMENT_DURATION: {
    token: '{{assessment_duration}}',
    key: 'assessment_duration'
  },
  ASSESSMENT_DEADLINE: {
    token: '{{assessment_deadline}}',
    key: 'assessment_deadline'
  },
  FIRSTNAME: { token: '{{firstname}}', key: 'firstname' },
  LASTNAME: { token: '{{lastname}}', key: 'lastname' },
  // Steht in alten Vorlagen, das Backend macht daraus einen Start-Link. Gilt
  // weiter, wird aber nicht mehr zum Einfügen angeboten.
  INVITATION_LINK: {
    token: '{{invitation_link}}',
    key: 'invitation_link',
    hidden: true
  }
}

export const MAIL_TEMPLATE_KINDS = {
  INVITE: 'invite',
  REMINDER: 'reminder',
  REJECT: 'reject',
  SUBJECT: 'subject'
}

// Reihenfolge ist die Reihenfolge im Menü
export const PLACEHOLDERS_BY_KIND = {
  [MAIL_TEMPLATE_KINDS.INVITE]: [
    'COMPANY_NAME',
    'CAREER_TITLE',
    'ASSESSMENT_DURATION',
    'ASSESSMENT_DEADLINE',
    'FIRSTNAME',
    'LASTNAME',
    'INVITATION_LINK'
  ],
  [MAIL_TEMPLATE_KINDS.REMINDER]: [
    'COMPANY_NAME',
    'CAREER_TITLE',
    'ASSESSMENT_DURATION',
    'ASSESSMENT_DEADLINE',
    'FIRSTNAME',
    'LASTNAME',
    'INVITATION_LINK'
  ],
  [MAIL_TEMPLATE_KINDS.REJECT]: [
    'COMPANY_NAME',
    'CAREER_TITLE',
    'FIRSTNAME',
    'LASTNAME'
  ],
  // Im Betreff ersetzt inviteTalent nur Firma und Stelle
  [MAIL_TEMPLATE_KINDS.SUBJECT]: ['COMPANY_NAME', 'CAREER_TITLE']
}

export const KNOWN_PLACEHOLDER_TOKENS = Object.values(PLACEHOLDERS).map(
  ({ token }) => token
)

// Gleiche Namen in inviteTalent für die Test-Mail (aivy-backend-app,
// inviteTalent/src/test-mail.js)
export const EXAMPLE_NAMES = {
  de: { firstname: 'Max', lastname: 'Mustermann' },
  en: { firstname: 'Alex', lastname: 'Smith' }
}
